import * as P from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as Z } from "../../utilities/uv.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as oo } from "../../helpers/distort.js";
import { glow as to } from "../../helpers/glow.js";
import { edgeMask as no } from "../../helpers/edgeMask.js";
const _o = {
  name: "ChromaticSoft5",
  collection: "chromatic-soft",
  tags: ["wave", "gradient"],
  props: {
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the wave effect."
    }
  },
  fragmentNode: (f) => {
    const {
      vec3: E,
      vec4: l,
      time: O,
      mix: n,
      sin: T,
      float: o,
      pow: s,
      uv: N,
      color: t
    } = P, a = t("#dcff49"), S = t("#8ae64c"), p = t("#99e47a"), u = t("#7bbc50"), C = t("#5adc4b"), R = t("#3a9833"), D = -0.5, G = 1, I = 0, L = 0, g = 0.2, A = 0.5, b = 20, F = 0.2, v = 0.05, w = 1, U = 0.6, Y = 0.4, x = 1, V = 1, c = N(), { correctedUV: W } = Z(), _ = oo(c, g, A, b), h = s(a, o(2.2)), y = s(S, o(2.2)), B = s(p, o(2.2)), k = s(u, o(2.2)), H = n(
      h,
      y,
      c.x
    ), K = n(
      k,
      B,
      c.x
    ), Q = n(
      H,
      K,
      c.y
    ), d = _.x.sub(0.5), i = _.y.sub(0.5), X = i.mul(d).add(i.mul(d)).negate(), r = o(1).add(
      o(F).mul(
        T(
          X.add(O.mul(f.speed.uniform).mul(0.025)).div(v)
        )
      )
    ), z = no({
      inset: D,
      softness: G,
      offsetX: I,
      offsetY: L
    }), M = E(r, r, r).mul(z).mul(w), j = n(
      R,
      C,
      c.y
    ), m = $(U)(W), e = Q.mul(M).add(m), q = e.r.add(e.g).add(e.b), J = l(
      n(j.add(m), e, q),
      1
    );
    return to(J, a, Y, x, V);
  }
};
export {
  _o as componentDefinition,
  _o as default
};
